<div
  class="d-inline-flex align-items-center cursor-pointer"
  (click)="sortingClicked()"
>
  <span> {{ headerText }}</span>
  <div class="sorting-icons-container d-inline-flex flex-column pl-2">
    <fa-icon
      [icon]="['fas', 'angle-up']"
      class="sorting-icons"
      data-e2e="sorting-arrow-asc"
      [ngClass]="{
        active: isActive(DashboardColumnSortDirection.Ascending)
      }"
    ></fa-icon>
    <fa-icon
      [icon]="['fas', 'angle-down']"
      class="sorting-icons"
      data-e2e="sorting-arrow-desc"
      [ngClass]="{
        active: isActive(DashboardColumnSortDirection.Descending)
      }"
    ></fa-icon>
  </div>
</div>
